
    import Ember from 'ember';
    import "coffeescripts/ember/shared/helpers/common";
import "i18n!screenreader_gradebook.outcome_information";

    Ember.TEMPLATES['outcome_information'] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("\n        <h3 class=\"outcome_selection\">\n          ");
  stack1 = helpers._triageMustache.call(depth0, "selectedOutcome.title", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n        </h3>\n        ");
  stack1 = helpers['if'].call(depth0, "calculationDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(2, program2, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n        <div class=\"pad-box no-sides\">\n          <p><strong>\n            ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'outcomeDetails.cnt': ("outcomeDetails.cnt"),
    'i18n_inferred_key': (false)
  },hashTypes:{'outcomeDetails.cnt': "ID",'i18n_inferred_key': "BOOLEAN"},hashContexts:{'outcomeDetails.cnt': depth0,'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "total_results_outcomedetails_cnt_30ff1f8d", "Total results: %{outcomeDetails.cnt}", options) : helperMissing.call(depth0, "t", "total_results_outcomedetails_cnt_30ff1f8d", "Total results: %{outcomeDetails.cnt}", options))));
  data.buffer.push("\n          </strong></p>\n        </div>\n\n        <div class=\"pad-box bottom-only\">\n          <table class=\"ic-Table\">\n            <thead>\n              <tr>\n                ");
  stack1 = helpers['if'].call(depth0, "outcomeDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                ");
  stack1 = helpers['if'].call(depth0, "outcomeDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(9, program9, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      ");
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("\n          ");
  stack1 = helpers['with'].call(depth0, "calculationDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(3, program3, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n        ");
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("\n            <div class=\"method-details content-box pad-box-mini border border-trbl border-round\">\n              <div>\n                ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "calculation_method_fe281f9", "Calculation Method", options) : helperMissing.call(depth0, "t", "calculation_method_fe281f9", "Calculation Method", options))));
  data.buffer.push(":\n                <span class=\"right-content\">");
  stack1 = helpers._triageMustache.call(depth0, "calculation_method", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span>\n              </div>\n              <div class=\"example\">\n                <span class=\"left-content\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "example_84698b7d", "Example", options) : helperMissing.call(depth0, "t", "example_84698b7d", "Example", options))));
  data.buffer.push(": </span>\n                <span class=\"right-content method-description\">");
  stack1 = helpers._triageMustache.call(depth0, "exampleText", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span>\n              </div>\n              <div class=\"example\">\n                <span aria-hidden=\"true\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "1_item_scores_5512cd03", "1- Item scores", options) : helperMissing.call(depth0, "t", "1_item_scores_5512cd03", "1- Item scores", options))));
  data.buffer.push(": </span>\n                <span class=\"screenreader-only\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "example_item_scores_6726c689", "Example item scores", options) : helperMissing.call(depth0, "t", "example_item_scores_6726c689", "Example item scores", options))));
  data.buffer.push(": </span>\n                <span class=\"right-content\">");
  stack1 = helpers._triageMustache.call(depth0, "exampleScores", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span>\n              </div>\n              <div class=\"example\">\n                <span aria-hidden=\"true\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "2_final_score_7b0fd15e", "2- Final score", options) : helperMissing.call(depth0, "t", "2_final_score_7b0fd15e", "2- Final score", options))));
  data.buffer.push(": </span>\n                <span class=\"screenreader-only\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "example_final_score_355aff0f", "Example final score", options) : helperMissing.call(depth0, "t", "example_final_score_355aff0f", "Example final score", options))));
  data.buffer.push("</span>\n                <span class=\"right-content\">");
  stack1 = helpers._triageMustache.call(depth0, "exampleResult", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</span>\n              </div>\n            </div>\n          ");
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("\n                  ");
  stack1 = helpers['with'].call(depth0, "outcomeDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(6, program6, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n                ");
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("\n                    ");
  stack1 = helpers['if'].call(depth0, "cnt", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n                  ");
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n                      <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.outcome_information")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "avg_score", "Average Score", options) : helperMissing.call(depth0, "t", "avg_score", "Average Score", options))));
  data.buffer.push("</th>\n                      <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.outcome_information")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "high_score", "High Score", options) : helperMissing.call(depth0, "t", "high_score", "High Score", options))));
  data.buffer.push("</th>\n                      <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.outcome_information")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "low_score", "Low Score", options) : helperMissing.call(depth0, "t", "low_score", "Low Score", options))));
  data.buffer.push("</th>\n                    ");
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("\n                  ");
  stack1 = helpers['with'].call(depth0, "outcomeDetails", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(10, program10, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n                ");
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = '', stack1;
  data.buffer.push("\n                    ");
  stack1 = helpers['if'].call(depth0, "cnt", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(11, program11, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n                  ");
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n                      <td>");
  data.buffer.push(escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },hashTypes:{'format': "STRING"},hashContexts:{'format': depth0},contexts:[depth0],types:["ID"],data:data},helper ? helper.call(depth0, "average", options) : helperMissing.call(depth0, "nf", "average", options))));
  data.buffer.push("</td>\n                      <td>");
  data.buffer.push(escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },hashTypes:{'format': "STRING"},hashContexts:{'format': depth0},contexts:[depth0],types:["ID"],data:data},helper ? helper.call(depth0, "max", options) : helperMissing.call(depth0, "nf", "max", options))));
  data.buffer.push("</td>\n                      <td>");
  data.buffer.push(escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },hashTypes:{'format': "STRING"},hashContexts:{'format': depth0},contexts:[depth0],types:["ID"],data:data},helper ? helper.call(depth0, "min", options) : helperMissing.call(depth0, "nf", "min", options))));
  data.buffer.push("</td>\n                    ");
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n        <p class=\"outcome_selection pad-box top-only\">\n          ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.outcome_information")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "empty_outcome_selection", "Select an outcome to view additional information here.", options) : helperMissing.call(depth0, "t", "empty_outcome_selection", "Select an outcome to view additional information here.", options))));
  data.buffer.push("\n        </p>\n      ");
  return buffer;
  }

  data.buffer.push("<div id=\"outcome_information\">\n  <div class=\"row-fluid\">\n    <div class=\"span4\">\n      <h2>");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.outcome_information")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "outcome_info", "Outcome Information", options) : helperMissing.call(depth0, "t", "outcome_info", "Outcome Information", options))));
  data.buffer.push("</h2>\n    </div>\n    <div class=\"span8\">\n      ");
  stack1 = helpers['if'].call(depth0, "selectedOutcome", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(13, program13, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n    </div>\n  </div>\n</div>\n");
  return buffer;
  
});
  